import { isPatron } from "util";

import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

import Ad from "components/Ad/Ad";
import PleaseSupportUs from "components/PleaseSupportUs";
import useCanRunAds from "hooks/useCanRunAds";

import styles from "./Leaderboard.module.scss";

const Leaderboard = () => {
  const canRunAds = useCanRunAds();
  const profile = useSelector((state) => state.firebase.profile);
  const [randomRoll, setRandomRoll] = useState(Math.random());
  const locationRef = useRef();
  const location = useLocation();

  useEffect(() => {
    if (!locationRef.current) locationRef.current = location;
    else setRandomRoll(Math.random());
  }, [location]);

  if (isPatron(profile)) return null;

  const ad =
    !canRunAds || randomRoll < 1 / 2 ? (
      <PleaseSupportUs always height={90} width={728} />
    ) : randomRoll < 6 / 10 ? (
      <Ad id="archidekt" />
    ) : randomRoll < 7 / 10 ? (
      <Ad id="cc" />
    ) : randomRoll < 8 / 10 ? (
      <Ad id="ch" />
    ) : randomRoll < 9 / 10 ? (
      <Ad id="csb" />
    ) : (
      <Ad id="fabrec" />
    );

  return <div className={styles.leaderboard}>{ad}</div>;
};

export default Leaderboard;
